import React, { useEffect, useState } from "react";
import { ExportIcon, RefreshIcon } from "../../assets/icons";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { reqToGetFeedBackAnalytics } from "../../redux/slices.js/feedback/feedBackSlice";
import { DatePicker, message } from "antd";

const Analytics = () => {
  const dispatch = useDispatch();
  const [selectedCycle, setSelectedCycle] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedRecipient, setSelectedRecipient] = useState(null);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const analyticsData = useSelector(
    (state) => state.feedbackslice.feedbackAnalytics
  );

  const { RangePicker } = DatePicker;

  useEffect(() => {
    dispatch(
      reqToGetFeedBackAnalytics({
        data: { action: "dashboard" },
        onSuccess: () => {},
        onFailure: () => {},
      })
    );
  }, [dispatch]);

  const handleExport = () => {
    // Map the selected items to the required query parameters
    const queryParams = {
      action: "export",
      dateType: selectedDateRange ? "custom" : "", // Changed to "custom" since we're using date picker
      startDate: selectedDateRange
        ? selectedDateRange[0]?.format("YYYY-MM-DD")
        : "",
      endDate: selectedDateRange
        ? selectedDateRange[1]?.format("YYYY-MM-DD")
        : "",
      analytic: selectedItems.includes("Analytics Data"),
      votes: selectedItems.includes("Vote History"),
      comments: selectedItems.includes("Comments"),
      feedback_items: selectedItems.includes("Feedback Items"),
    };

    dispatch(
      reqToGetFeedBackAnalytics({
        data: queryParams,
        onSuccess: () => {
          dispatch(
            reqToGetFeedBackAnalytics({
              data: { action: "dashboard" },
              onSuccess: () => {},
              onFailure: () => {},
            })
          );
        },
        onFailure: () => {
          console.log("Export failed");
        },
      })
    );
  };

  const handleItemChange = (item) => {
    setSelectedItems((prev) => {
      if (prev.includes(item)) {
        return prev.filter((i) => i !== item);
      } else {
        return [...prev, item];
      }
    });
  };

  const handleRecipientChange = (selectedOption) => {
    setSelectedRecipient(selectedOption);
  };

  const handleDateRangeChange = (dates) => {
    setSelectedDateRange(dates);
  };

  const stats = [
    {
      id: 1,
      title: "Monthly Growth",
      value: analyticsData ? `${analyticsData.monthly_growth}%` : "0%",
      color: "text-blue-100",
    },
    {
      id: 2,
      title: "Avg Resolution Time",
      value: analyticsData
        ? `${analyticsData.avg_resolution_time} days`
        : "0 days",
      color: "text-blue-100",
    },
    {
      id: 3,
      title: "Satisfaction Score",
      value: analyticsData ? `${analyticsData.satisfaction_score}/10` : "0/10",
      color: "text-green",
    },
    {
      id: 4,
      title: "Active Reporters",
      value: analyticsData ? `${analyticsData.active_reporters}` : "0",
      color: "text-green",
    },
  ];

  const items = [
    "Feedback Items",
    "Comments",
    "Vote History",
    "Analytics Data",
  ];
  const billingCycles = [
    { label: "CSV", value: "CSV" },
    { label: "PDF", value: "PDF" },
    { label: "EXCEL", value: "EXCEL" },
  ];
  const handleChange = (event) => {
    setSelectedCycle(event.target.value);
  };
  const recipientOptions = [
    { value: "john", label: "John Doe" },
    { value: "sarah", label: "Sarah Miller" },
    { value: "mike", label: "Mike Wilson" },
  ];

  return (
    <div className="space-y-5">
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {stats.map((item) => (
          <div key={item.id} className="px-5 py-6 border rounded-[10px]">
            <h4 className="text-sub_span !font-medium text-black">
              {item.title}
            </h4>
            <p className={`text-p !font-semibold mb-0 ${item.color}`}>
              {item.value}
            </p>
          </div>
        ))}
      </div>
      <div className="chart-card w-full md:col-span-2 xl:col-span-3">
        <div className="flex items-center justify-between flex-wrap gap-2 border-b-[1px] border-[D3D6DA3B] pb-[10px]">
          <h3 className="text-span text-black !font-semibold mb-0 p-0">
            Analytic Reports
          </h3>
          <div className="heading-btns flex items-center gap-3">
            <button className="btn-light-gray !text-[#4285F4]">
              {RefreshIcon}Dashboard
            </button>
            <button className="btn-light-blue" onClick={handleExport}>
              {ExportIcon}Export Data
            </button>
          </div>
        </div>
        <div className="mt-2">
          <form className="comman-form flex flex-col pt-3 space-y-6">
            <div className="form-group">
              <label>Export options</label>
              <div className="flex flex-wrap gap-x-[90px] gap-y-2 mt-4">
                {items.map((item, index) => (
                  <label
                    key={index}
                    className="flex items-center gap-3 cursor-pointer select-none"
                  >
                    <div className="relative !h-5 !w-5">
                      <input
                        type="checkbox"
                        className="peer hidden !p-0"
                        checked={selectedItems.includes(item)}
                        onChange={() => handleItemChange(item)}
                      />
                      <span className="flex h-5 w-5 items-center justify-center rounded-[16px] border-2 border-[#9BA2AB] peer-checked:border-[#4285F4] bg-white peer-checked:bg-white"></span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="hidden h-4 w-4 text-[#4285F4] peer-checked:block absolute top-[90%] left-[90%] -translate-x-1/2 -translate-y-1/2"
                        fill="#4285F4"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="text-black text-span !leading-[15px] !tracking-[0]">
                      {item}
                    </div>
                  </label>
                ))}
              </div>
            </div>
            <div className="form-group pt-3">
              <label>Format</label>
              <div className="flex space-x-10 flex-wrap items-center mt-4">
                {billingCycles.map((cycle) => (
                  <label
                    key={cycle.value}
                    className="flex items-center cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="billing-cycle"
                      value={cycle.value}
                      checked={selectedCycle === cycle.value}
                      onChange={handleChange}
                      className="hidden"
                    />
                    <span
                      className={`w-5 h-5 rounded-full border-2 ${
                        selectedCycle === cycle.value
                          ? "bg-blue-500 border-blue-500"
                          : "bg-white border-gray-300"
                      } flex items-center justify-center`}
                    >
                      {selectedCycle === cycle.value && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 text-blue-500"
                          fill="#fff"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      )}
                    </span>
                    <div className="ml-2 text-black text-span">
                      {cycle.label}
                    </div>
                  </label>
                ))}
              </div>
            </div>

            <div className="form-group pt-3">
              <label>
                Recipient <span>*</span>
              </label>
              <Select
                options={recipientOptions}
                placeholder="Select industry"
                isClearable={false}
                isSearchable={false}
                menuPlacement="auto"
                value={selectedRecipient}
                onChange={handleRecipientChange}
              />
            </div>
            <div className="form-group">
              <label>
                Date Range <span>*</span>
              </label>
              <RangePicker
                onChange={handleDateRangeChange}
                disabledDate={(current) => current && current > new Date()}
                className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:border-blue-500"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
